// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"88a3c9d5","129":"6c3ba4f5","491":"5898c61a","655":"baad8612","691":"450179f6","908":"c7eca886"}[chunkId] + ".chunk.css";
};